import { defineRouteMeta } from '@/router/helpers/defineRouteMeta';

const MarketingEblastList = () => import(/* webpackChunkName: "marketing" */ '@/bundles/Marketing/views/MarketingEblastList.vue');
const MarketingEblastRecord = () => import(/* webpackChunkName: "marketing" */ '@/bundles/Marketing/views/MarketingEblastRecord.vue');

export default [
  {
    path: 'marketing/eblasts',
    name: 'marketing-eblasts', // :key="$route.fullPath" removed
    component: MarketingEblastList,
    props: true,
    meta: defineRouteMeta({
      title: 'Marketing Eblasts',
    }),
  },
  {
    path: 'marketing/eblast/:id',
    name: 'marketing-eblast-record',
    component: MarketingEblastRecord,
    props: true,
    meta: defineRouteMeta({
      appShell: true,
      title: 'Marketing Eblast',
      topBarTitle: 'Eblast Record',
      topBarSource: 'eblast',
    }),
  }
];
